import { IconButton } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { memo, ReactElement, useCallback, useState } from 'react';
import { LanguageSelectionDialog } from '../LanguageSelectionDialog';

export const LanguageSelector = memo(function LanguageSelector(): ReactElement {
  const [languageDialogOpen, setLanguageDialogOpen] = useState(false);

  const handleLanguageIconClick = useCallback(() => {
    setLanguageDialogOpen(true);
  }, []);

  const handleLanguageDialogClose = useCallback(() => {
    setLanguageDialogOpen(false);
  }, []);

  return (
    <>
      <IconButton onClick={handleLanguageIconClick} size='medium'>
        <LanguageIcon htmlColor='white' fontSize='medium' />
      </IconButton>
      <LanguageSelectionDialog isOpen={languageDialogOpen} onClose={handleLanguageDialogClose} />
    </>
  );
});
